import { memo, useContext, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const Sample = memo(() => {
  const { inputs, setInputs, errors, setErrors } = useContext(Data);
  useEffect(() => {
    setErrors({
      ...errors,
      sample: inputs.sample === null ? "*必須" : null,
    });
    return () => {
      setErrors({
        ...errors,
        sample: null,
      });
    };
  }, []);
  const colorList = [
    "グリーン系",
    "グレー系",
    "ブルー系",
    "ホワイト、アイボリー系",
    "ブラック系",
    "ダークブラウン系",
    "ブラウン系",
    "レッド系",
    "イエロー系",
    "オレンジ系",
    "その他",
  ];
  const sampleSelect = (e) => {
    setInputs({ ...inputs, sample: e.target.value });
    setErrors({ ...errors, sample: null });
  };
  return (
    <>
      <div className={styles.selectBox}>
        <p className="bold">ご検討カラー</p>
        <div>
          <select name="color">
            <option disabled selected>
              選択してください
            </option>
            {colorList.map((item, index) => {
              return (
                <option key={index} value={item}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className={styles.radioBox}>
        <p className="bold">
          生地サンプルの希望<span>{errors.sample}</span>
        </p>
        <div>
          <label>
            <input
              type="radio"
              name="sample"
              value="あり"
              onChange={sampleSelect}
              checked={inputs.sample === "あり" ? true : false}
            />
            あり
          </label>
          <label>
            <input
              type="radio"
              name="sample"
              value="なし"
              onChange={sampleSelect}
              checked={inputs.sample === "なし" ? true : false}
            />
            なし
          </label>
        </div>
      </div>
    </>
  );
});

export default Sample;
